// eslint-disable-next-line import/prefer-default-export
export const strToReactSelectItem = (str) => ({ label: str, value: str });
